export default __webpack_public_path__ + "static/media/piano_2.653ab7b4.png";